import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';

export const REPORT_QUERY_KEY = 'reports.getReport';

export const useGetReport = ({ id }: { id?: string }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error, refetch } = useQuery<
    Awaited<ReturnType<typeof api.reports.getReport>>,
    AxiosApiError
  >({
    queryKey: [REPORT_QUERY_KEY, { id, tenantId }],
    queryFn: () => api.reports.getReport(tenantId, id ?? ''),
    enabled: !!id && !!tenantId,
  });

  return {
    report: data?.data.report,
    isLoading,
    error,
    refetch,
  };
};
